// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ed9add34","667":"7884ff22"}[chunkId] + ".chunk.js";
};